<template>
  <div class="ioRecord" v-loading="loading">
    <div class="right">
      <!-- 搜索框 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="couponName">优惠券名称:</label>
            <el-input
              v-model="search.couponName"
              placeholder="请输入优惠券名称"
            ></el-input>
          </div>
          <div class="form-group">
            <label for="merchantName">商家名称:</label>
            <el-input
              v-model="search.merchantName"
              placeholder="请输入商家名称"
            ></el-input>
          </div>
          <!-- <div class="form-group">
            <label for="userPhone">用户手机号:</label>
            <el-input
              v-model="search.userPhone"
              placeholder="请输入用户手机号"
            ></el-input>
          </div> -->
          <div class="form-group">
            <label for="verificationTime">核销时间:</label>
            <el-date-picker
            width="100%"
              v-model="search.verificationTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
        </form>
      </div>

      <!-- 状态标签页 -->
      <!-- <div class="status-tabs">
        <el-tabs v-model="activeStatus" @tab-click="handleStatusChange">
          <el-tab-pane label="全部" name="all">
            <span slot="label">
              全部
              <el-badge :value="statusCounts.all" class="status-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="核销成功" name="1">
            <span slot="label">
              核销成功
              <el-badge :value="statusCounts.success" class="status-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="核销失败" name="2">
            <span slot="label">
              核销失败
              <el-badge :value="statusCounts.failed" class="status-badge" />
            </span>
          </el-tab-pane>
        </el-tabs>
      </div> -->

      <div v-show="showList" class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="优惠券名称"
            prop="couponName"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="商家名称"
            prop="merchantName"
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="优惠券类型"
        
            width="100"
          >
            <template slot-scope="scope">
              <span>{{ getCouponTypeName(scope.row.discountType) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="优惠券内容"
           
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ getCouponContent(scope.row) }}</span>
            </template>
        </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="用户手机号"
            prop="phone"
            width="120"
          >
          <!-- <template slot-scope="scope">
              <span>{{ maskPhone(scope.row.phone) }}</span>
            </template> -->
        </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="用户姓名"
            prop="userName"
            width="100"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="核销时间"
            prop="userTime"
            width="150"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="核销金额"
            prop="verificationAmount"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.verificationAmount"
                >¥{{ scope.row.verificationAmount }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="核销人姓名"
            prop="userName"
            width="100"
          ></el-table-column>
         
          <!-- <el-table-column
            show-overflow-tooltip
            label="核销方式"
            prop="verificationMethod"
            width="100"
          ></el-table-column> -->
          <!-- <el-table-column
            show-overflow-tooltip
            label="状态"
            prop="status"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">
                {{ getStatusName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column show-overflow-tooltip label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewDetail(scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      title="核销记录详情"
      :visible.sync="showDetailDialog"
      width="600px"
      @close="closeDetailDialog"
    >
      <div v-if="currentRecord" class="detail-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券名称：</label>
              <span>{{ currentRecord.couponName }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>商家名称：</label>
              <span>{{ currentRecord.merchantName }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券类型：</label>
              <span>{{ getCouponTypeName(currentRecord.discountType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券内容：</label>
              <span>{{ getCouponContent(currentRecord) }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>用户手机号：</label>
              <span>{{ currentRecord.phone }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="detail-item">
              <label>用户姓名：</label>
              <span>{{ currentRecord.userName }}</span>
            </div>
          </el-col> -->
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>核销时间：</label>
              <span>{{ currentRecord.userTime }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="detail-item">
              <label>核销金额：</label>
              <span v-if="currentRecord.verificationAmount"
                >¥{{ currentRecord.verificationAmount }}</span
              >
              <span v-else>-</span>
            </div>
          </el-col> -->
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>核销人员：</label>
              <span>{{ currentRecord.userName }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="detail-item">
              <label>核销方式：</label>
              <span>{{ currentRecord.verificationMethod }}</span>
            </div>
          </el-col> -->
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>核销备注：</label>
              <span>{{ currentRecord.verificationRemark || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>状态：</label>
              <el-tag :type="getStatusType(currentRecord.status)">
                {{ getStatusName(currentRecord.status) }}
              </el-tag>
            </div>
          </el-col>
        </el-row> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </div>
    </el-dialog>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import { shopCouponReceiveList } from "@/api/url";
export default {
  name: "verification-record",
  components: {
    Page,
  },
  data() {
    return {
      loading: false,
      moduleName: "verification-record",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      total: 0,
      showList: true,
      search: {
        pageSize: 10,
        pageNumber: 1,
        couponName: "",
        merchantName: "",
        verificationTime: [],
      },
      currentRecord: null,
      showDetailDialog: false,

      // 状态标签页相关
      activeStatus: "all",
      statusCounts: {
        all: 0,
        success: 0,
        failed: 0,
      },
    };
  },
  mounted() {
    this.tableList(1);
  },
  methods: {
    ...mapMutations(["getPage"]),

    // 分页数据接收
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    // 获取核销记录列表
    tableList(curPage) {
      this.loading = true;
      const params = {
        page: curPage,
        limit: this.search.pageSize,
        status:2,
        couponName: this.search.couponName.trim(),
        merchantName: this.search.merchantName.trim(),
        beginTime: this.search.verificationTime[0],
        endTime: this.search.verificationTime[1],
      };
      this.$get(shopCouponReceiveList(), params)
        .then((res) => {
          this.tableListData = res.data.rows || [];
          //翻页
          var pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.getPage(pageObj);
        })
        .catch((error) => {
          // 如果接口失败，使用测试数据
          // this.loadTestMerchantData();
        })
        .finally(() => {
          this.loading = false;
        });

      // 使用测试数据
      // const allData = [
      //   {
      //     id: 1,
      //     couponName: "新用户专享券",
      //     merchantName: "星巴克咖啡",
      //     couponType: "1",
      //     couponContent: "满100减20，新用户专享优惠",
      //     userPhone: "13800138001",
      //     userName: "张三",
      //     verificationTime: "2024-01-16 10:20:00",
      //     verificationAmount: 20.00,
      //     verificationStaff: "李经理",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "正常核销",
      //     status: "1"
      //   },
      //   {
      //     id: 2,
      //     couponName: "停车代金券",
      //     merchantName: "万达广场",
      //     couponType: "3",
      //     couponContent: "停车费用减免5元",
      //     userPhone: "13800138003",
      //     userName: "王五",
      //     verificationTime: "2024-01-18 11:30:00",
      //     verificationAmount: 5.00,
      //     verificationStaff: "张主管",
      //     verificationMethod: "手动核销",
      //     verificationRemark: "停车费减免",
      //     status: "1"
      //   },
      //   {
      //     id: 3,
      //     couponName: "早鸟优惠券",
      //     merchantName: "永辉超市",
      //     couponType: "1",
      //     couponContent: "满50减10，早鸟专享",
      //     userPhone: "13800138005",
      //     userName: "孙七",
      //     verificationTime: "2024-01-20 08:15:00",
      //     verificationAmount: 10.00,
      //     verificationStaff: "陈收银",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "早鸟优惠",
      //     status: "1"
      //   },
      //   {
      //     id: 4,
      //     couponName: "生日特惠券",
      //     merchantName: "必胜客",
      //     couponType: "2",
      //     couponContent: "生日月享受6折优惠",
      //     userPhone: "13800138007",
      //     userName: "吴九",
      //     verificationTime: "2024-01-23 19:20:00",
      //     verificationAmount: 15.00,
      //     verificationStaff: "刘经理",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "生日优惠",
      //     status: "1"
      //   },
      //   {
      //     id: 5,
      //     couponName: "新用户专享券",
      //     merchantName: "星巴克咖啡",
      //     couponType: "1",
      //     couponContent: "满100减20，新用户专享优惠",
      //     userPhone: "13800138009",
      //     userName: "钱十一",
      //     verificationTime: "2024-01-16 14:30:00",
      //     verificationAmount: 20.00,
      //     verificationStaff: "李经理",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "正常核销",
      //     status: "1"
      //   },
      //   {
      //     id: 6,
      //     couponName: "周末特惠券",
      //     merchantName: "麦当劳",
      //     couponType: "2",
      //     couponContent: "周末购物享受8.5折优惠",
      //     userPhone: "13800138002",
      //     userName: "李四",
      //     verificationTime: "2024-01-17 12:45:00",
      //     verificationAmount: 8.50,
      //     verificationStaff: "王收银",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "周末优惠",
      //     status: "2"
      //   },
      //   {
      //     id: 7,
      //     couponName: "夜猫子券",
      //     merchantName: "7-11便利店",
      //     couponType: "3",
      //     couponContent: "夜间停车减免3元",
      //     userPhone: "13800138006",
      //     userName: "周八",
      //     verificationTime: "2024-01-22 23:30:00",
      //     verificationAmount: 3.00,
      //     verificationStaff: "赵值班",
      //     verificationMethod: "手动核销",
      //     verificationRemark: "夜间优惠",
      //     status: "1"
      //   },
      //   {
      //     id: 8,
      //     couponName: "会员专享券",
      //     merchantName: "肯德基",
      //     couponType: "1",
      //     couponContent: "满200减50，会员专享",
      //     userPhone: "13800138004",
      //     userName: "赵六",
      //     verificationTime: "2024-01-19 18:20:00",
      //     verificationAmount: 50.00,
      //     verificationStaff: "孙经理",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "会员专享",
      //     status: "2"
      //   },
      //   {
      //     id: 9,
      //     couponName: "节日特惠券",
      //     merchantName: "海底捞",
      //     couponType: "2",
      //     couponContent: "节日期间享受7折优惠",
      //     userPhone: "13800138008",
      //     userName: "郑十",
      //     verificationTime: "2024-01-20 20:15:00",
      //     verificationAmount: 25.00,
      //     verificationStaff: "周主管",
      //     verificationMethod: "扫码核销",
      //     verificationRemark: "节日优惠",
      //     status: "1"
      //   },
      //   {
      //     id: 10,
      //     couponName: "停车代金券",
      //     merchantName: "万达广场",
      //     couponType: "3",
      //     couponContent: "停车费用减免5元",
      //     userPhone: "13800138010",
      //     userName: "陈十二",
      //     verificationTime: "2024-01-21 16:40:00",
      //     verificationAmount: 5.00,
      //     verificationStaff: "张主管",
      //     verificationMethod: "手动核销",
      //     verificationRemark: "停车费减免",
      //     status: "2"
      //   }
      // ];

      // // 模拟搜索过滤
      // let filteredData = allData;
      // if (this.search.couponName) {
      //   filteredData = filteredData.filter(item =>
      //     item.couponName.includes(this.search.couponName)
      //   );
      // }
      // if (this.search.merchantName) {
      //   filteredData = filteredData.filter(item =>
      //     item.merchantName.includes(this.search.merchantName)
      //   );
      // }
      // if (this.search.userPhone) {
      //   filteredData = filteredData.filter(item =>
      //     item.userPhone.includes(this.search.userPhone)
      //   );
      // }
      // if (this.search.verificationTime && this.search.verificationTime.length === 2) {
      //   const startDate = this.search.verificationTime[0];
      //   const endDate = this.search.verificationTime[1];
      //   filteredData = filteredData.filter(item => {
      //     const verificationDate = item.verificationTime.split(' ')[0];
      //     return verificationDate >= startDate && verificationDate <= endDate;
      //   });
      // }

      // // 状态过滤
      // if (this.search.status !== "") {
      //   filteredData = filteredData.filter(item =>
      //     item.status === this.search.status
      //   );
      // }

      // // 模拟分页
      // const startIndex = (curPage - 1) * this.search.pageSize;
      // const endIndex = startIndex + this.search.pageSize;
      // this.tableListData = filteredData.slice(startIndex, endIndex);
      // this.total = filteredData.length;

      // // 更新状态统计
      // this.updateStatusCounts(allData);
    },

    // 更新状态统计
    // updateStatusCounts(allData) {
    //   this.statusCounts = {
    //     all: allData.length,
    //     success: allData.filter(item => item.status === "1").length,
    //     failed: allData.filter(item => item.status === "2").length
    //   };
    // },

    // 搜索
    searchList() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },

    // 获取优惠券类型名称
    getCouponTypeName(type) {
      const typeMap = {
        1: "满减券",
        3: "折扣券",
        5: "抵扣券",
      };
      return typeMap[type] || "优惠券";
    },
// 获取优惠券内容
    getCouponContent(row) {
      const { discountType, thresholdAmount, discountValue } = row;
      
      if (!thresholdAmount && !discountValue) {
        return row.couponContent || '';
      }
      
      switch (discountType) {
        case 1: // 满减券
          return `满${thresholdAmount}元，减${discountValue}元`;
        case 3: // 折扣券
          return `满${thresholdAmount}元，打${discountValue}折`;
        case 5: // 代金券
          return `满${thresholdAmount}元，${discountValue}元`;
        default:
          return row.couponContent || '';
      }
    },
    // 手机号脱敏处理
    maskPhone(phone) {
      if (!phone) return '';
      if (phone.length === 11) {
        // 标准11位手机号：显示前3位和后4位，中间用*代替
        return phone.substring(0, 3) + '****' + phone.substring(7);
      } else if (phone.length > 4) {
        // 其他长度的手机号：显示前2位和后2位，中间用*代替
        const start = phone.substring(0, 2);
        const end = phone.substring(phone.length - 2);
        const middle = '*'.repeat(phone.length - 4);
        return start + middle + end;
      }
      return phone;
    },
    // 获取状态名称
    getStatusName(status) {
      const statusMap = {
        1: "核销成功",
        2: "核销失败",
      };
      return statusMap[status] || "未知";
    },

    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        1: "success",
        2: "danger",
      };
      return typeMap[status] || "info";
    },

    // 状态标签页切换
    // handleStatusChange(tab) {
    //   this.search.status = tab.name === "all" ? "" : tab.name;
    //   this.search.pageNumber = 1;
    //   this.tableList(1);
    // },

    // 查看详情
    viewDetail(row) {
      this.currentRecord = row;
      this.showDetailDialog = true;
    },

    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetailDialog = false;
      this.currentRecord = null;
    },
  },
};
</script>

<style scoped>
.el-tag {
  margin: 0;
}

/* 状态标签页样式 */
.status-tabs {
  margin-bottom: 20px;
  background: #fff;
  padding: 0 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-tabs .el-tabs__header {
  margin: 0;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::before {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__active-bar {
  display: none;
}

.status-tabs .el-tabs__item {
  border-bottom: none !important;
}

.status-tabs .el-tabs__content {
  border: none !important;
}

.status-tabs .el-tabs__header::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__header::before {
  display: none !important;
  content: none !important;
}

/* 强制移除所有可能的边框 */
.status-tabs .el-tabs {
  border: none !important;
}

.status-tabs .el-tabs__header {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav {
  border: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-scroll {
  border: none !important;
}

/* 移除所有伪元素的边框 */
.status-tabs *::before,
.status-tabs *::after {
  border: none !important;
  border-bottom: none !important;
}

/* 使用深度选择器强制覆盖 */
.status-tabs >>> .el-tabs__header {
  border-bottom: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap::after {
  display: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap {
  border-bottom: none !important;
}

/* 如果还是不行，尝试更具体的选择器 */
.status-tabs .el-tabs__header .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
  border: none !important;
}

.status-badge {
  margin-left: 8px;
}

/* 详情对话框样式 */
.detail-content {
  padding: 20px 0;
}

.detail-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.detail-item label {
  font-weight: 600;
  color: #333;
  min-width: 100px;
  margin-right: 10px;
}

.detail-item span {
  color: #666;
  flex: 1;
}
</style>
